module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapimage"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chapimage.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLOGUE")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_c('em', [_vm._v("Once Upon a Time")]), _vm._v(" . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("In the Land Beyond")]), _vm._v(" . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentz"
  }, [_vm._v("Crown Prince Jean-Marc, son of His Royal Majesty Henri III, Heir to the Throne of the Land Beyond, Beloved of Zeus, caught his breath as Lucienne, Princess of the Silver Hills, walked with her ladies and her priestesses into the airy, domed temple of his god. Sunshine poured in from the cloudless sky, tinting her magnificent silver gown with golden light. Over her braided silvery-blonde hair, she wore a tiara of glittering diamonds and enameled crescent moons, signifying her devotion to the goddess Artemis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her starry midnight-blue eyes gleamed as she caught sight of Jean-Marc waiting for her at the altar. He was dressed in ermine robes lined with gold, a black-and-gold doublet and black hose, and a heavy gold crown. Jean-Marc’s black hair curled around his ears, revealing the sharp planes and angles of his face, softened by his smile. His brows were dark, and his deep-set eyes darker, and filled with rapture as he gazed at Lucienne, his bride of four months.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The prince had been a solitary youth, left to his own devices by a father who married a succession of wives. Each queen had died—Jean-Marc’s mother, ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Marie, had been King Henri’s second wife—and the temple of Zeus had consecrated seven royal stepmothers since Jean-Marc’s birth. To think that at last the lonely prince had found a boon companion to share his life! Who would have dreamed that the prince and princess, joined together for political reasons, would fall so madly in love? It was enchanting. Miraculous. Surely a gift from the gods.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So it must be that Zeus, presiding in the form of a great marble statue, bearded and broad-chested, looked down on them with favor. Aglow with sunshine and torchlight, was he not smiling?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chief priest of Zeus stretched forth his arms in greeting. His two assistants flanked him. All three wore white togas bordered with gold, and crowns of laurel pushed low over their foreheads. The head priest was the oldest. On his right stood his associate, a priest in the fullness of his manhood; on the left, a boy acolyte, to signify the youngest age of man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King Henri, Jean-Marc’s father, was not there. The recent widower had been called away on matters of State, but he had toasted his son and daughter-in-law the night before, wishing them both the answer to all their prayers as the three tossed their golden goblets into the flames.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were about to hear if this month, that prayer would be answered.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The altar was covered with roses of scarlet and creamy ivory—red for the House of the Land Beyond, white for the Silver Hills. Also, vapors of ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("burning incense and towers of gleaming gold coins, payment for the gift of prophecy bestowed upon the three holy men. There were hundreds of coins, all graced with the likeness of Henri, and they would be given to the poor in the name of the king. The Land Beyond was the center of a vast realm and the treasury bulged with taxes and tribute.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucienne’s three priestesses, dressed in white robes caught at the shoulders with silver stars, wore diadems of the moon in her phases over long white gossamer veils that covered their braids. They carried diamond-studded silver arrows, symbols of their patroness, Artemis, Goddess of the Hunt and of the Moon. The priestess who led the procession was a crone, revered as a wisewoman and midwife. The priestess of childbearing age walked on Lucienne’s right. The third priestess, a newly consecrated maiden, held Lucienne’s left hand—the one nearer the princess’s heart—to give weight to Lucienne’s wish to bear the crown prince’s son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the priestesses reached the altar of their priestly counterparts, they regally inclined their heads and no more, for they were equals. But Lucienne made a full curtsy to the men of Zeus, which included her husband. Moving swiftly, Jean-Marc took his place beside her, and gallantly helped her to her feet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Jean-Marc laced his fingers through Lucienne’s. She squeezed his hand. He couldn’t take his eyes off her. Her dark blue eyes widened, framed by her ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("unusual silver-and-gold tresses, and the prince felt as though he were staring into the eyes of Artemis herself. He knew Lucienne had prayed to the Lady the night before and that the tender wishes of her women held great sway with the goddess.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have cast the runes,” the chief priest of Zeus announced as he lowered his gnarled hands to the altar. The other two priests lifted festoons of roses to reveal a round, beaten-gold tray, and on it, a simple scattering of ancient bone rectangles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jean-Marc and Lucienne held their breaths as both stared at the runes. They couldn’t read them. No man could, save the one who threw them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucienne’s mouth worked silently, praying to Artemis. Their hearts and bodies were new to each other, and yet both hoped, both dared . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have cast the runes,” the priest said again, his voice booming. His words echoed off the white stone columns, and he broke into a smile. “You will have a son in the spring and he will mend two broken hearts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucienne caught her breath and threw her arms around her husband. Aware of the young life inside her, Jean-Marc was afraid to hold her. But as she ecstatically melted against him, he grinned and caught her up, whirling her in a circle beneath the temple dome. She threw back her head and laughed, her golden hair flying behind her head like a cape.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“A son!” cried the priests, as the youngest one raced to the statue of Zeus and hefted the ceremonial ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("torch from the wall. He lit the enormous pile of papery-dry laurel leaves and oak branches in an alabaster bowl at the foot of the god. Smoke billowed and streamed toward the hole in the ceiling.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The priestesses took up the cry, raising their arrows above their heads. “A son!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside the temple, gongs clanged. Bells chimed. Cheers rose up. The kingdom began rejoicing. Riders bolted from the royal stables to carry the news far and wide. The gods were kind. The succession was assured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go and receive the blessing of the people,” Jean-Marc said, setting her down as if she were made of crystal and tenderly enfolding her hand with both of his. Jean-Marc could scarcely believe his good fortune. A son. His heir.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“First, I must thank the goddess,” she reminded him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll thank her too,” Jean-Marc said impetuously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But as they turned to go, the priest of Zeus cleared his throat and said, “Your Majesties, I ask your pardon, but it occurs to one that the prince might thank Father Zeus first, as "), _c('em', [_vm._v("he")]), _vm._v(" is your family’s patron.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shadow crossed Jean-Marc’s face, as if the massive statue of his god had shifted on its dais. Jean-Marc gazed up at the statue, and it stared impassively down at him. Chilled, the prince sank at once to his knees.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('em', [_vm._v("“M’excusez,”")]), _vm._v(" he murmured. “Of course. I owe my ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("loyalty and gratitude to the Lord of the Gods.” He lowered his head. “Forgive a thoughtless disciple.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“He accepts your apology. He is pleased with you,” the priest told Jean-Marc. His features softened. “After all, he’s giving you a son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jean-Marc smiled at the older man, but his princess looked troubled. She remained silent until the two had left the temple, but as their delighted guards grouped around them, she said softly, “Your god isn’t jealous, is he? He won’t punish you for forgetting to thank him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course he won’t punish me,” Jean-Marc scoffed. “I’m the son of the Land Beyond. Zeus favors my house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put his arm around her shoulders. He could hardly believe it. He had been alone most of his life, but he had a family now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The priest said our child would mend two broken hearts,” she persisted. “Whose hearts could those be, but ours? Broken because we angered the god?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps they’re my heart and my mother’s,” Jean-Marc replied. “I am told she wept when I was born, because she knew she was going to die.” And so she had, three days later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He spoke without self-pity, but his gentle princess, soon to be a mother herself, slipped her hand into his and said, “I won’t leave you. Ever.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("“Merci, ma belle,”")]), _vm._v(" he replied, and he suddenly felt a whisper of pain deep in his heart. Confused, he fell silent. This was one of the happiest moments of his ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("life; there was no cause for heartache. He pushed a smile onto his face. He didn’t want to dampen Lucienne’s joy. It was the dream of queens and princesses everywhere to give birth to an heir, and Lucienne’s dream would soon come true.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And she, and he, and their child, would live happily ever after.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Would they not?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0